import contractPage from '../../hoc/contractPage/contractPage';
import TermsAndConditions from '../../screens/TermsAndConditions/TermsAndConditions';
import getPageContent from '../../hoc/contractPage/getContent';

export async function getStaticProps() {
  const bank = await getPageContent('termsAndConditionsGeneralBank');

  return {
    props: {
      bank,
      seo: bank.seo,
    },
  };
}

export default contractPage(TermsAndConditions, {
  routeKey: 'TERMS_AND_CONDITIONS',
  allowApplicationForm: false,
});
